export default "__VITE_ASSET__201f3901__"